import { format, parseISO } from "date-fns";
import JSZip from "jszip";
import { CameraImageItem } from "@/types/Camera";

export const createZipFromUrls = async (imageList: CameraImageItem[]) => {
  const zip = new JSZip();
  const imagePromises = imageList.map(async (image) => {
    try {
      const response = await fetch(image.url);

      if (!response.ok) {
        // Skip this image and proceed to the next one.
        return null;
      }

      const blob = await response.blob();
      const imageDate = parseISO(image.timestamp);
      const fileName = `${format(imageDate, "dd-MM-yyyy")}.jpg`; // You can customize the file name as needed
      zip.file(fileName, blob);
    } catch (error) {
      const newError = new Error("Something went wrong while generating zip file") as Error & {
        innerError: unknown;
      };
      newError.innerError = error;
      throw newError;
    }
  });

  await Promise.all(imagePromises);

  return zip;
};

export const downloadZip = (zip: JSZip, name: string, start: string, end: string) => {
  zip.generateAsync({ type: "blob" }).then((content) => {
    const zipBlob = new Blob([content]);
    const zipUrl = URL.createObjectURL(zipBlob);
    const a = document.createElement("a");
    a.href = zipUrl;
    a.download = `${name}-${start}-${end}.zip`; // You can customize the zip file name
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(zipUrl);
  });
};

export default { createZipFromUrls, downloadZip };
